const GreekTaxInvoiceTypeEnum = Object.freeze({
    // If using 222 (which we're not) the customer's VAT number should go in field 2.
    INVOICE: 222, // Unused!
    RETAIL_POS_RECEIPT: 173,
    REPRINT: 502,
    CANCELLING_ORDER: 215,
});

module.exports = GreekTaxInvoiceTypeEnum;
